import { MoreVertical } from "react-feather";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { H4, P } from "../../../../../AbstractElements";
import { EducationAndEmploymentHeading } from "../../../../../Constants/Constants";
import { EducationData } from "../../../../../Data/Applications/SocialApp/SocialApp";

const EducationAndEmployment = () => {
  return (
    <Col sm="12">
      <Card>
        <CardHeader className="social-header">
          <H4>{EducationAndEmploymentHeading}<span className="pull-right"><MoreVertical /></span></H4>
        </CardHeader>
        <CardBody>
          {EducationData.map((data, index) => (
            <Row className="details-about" key={index}>
              <Col sm="6">
                <div className="your-details">
                  <span className="mb-2 d-block">{data.heading1}</span>
                  <P>{data.date1}</P>
                  <P>{data.paragraph1}</P>
                </div>
              </Col>
              <Col sm="6">
                <div className="your-details your-details-xs">
                  <span className="mb-2 d-block">{data.heading2}</span>
                  <P>{data.date2}</P>
                  <P>{data.paragraph2}</P>
                </div>
              </Col>
            </Row>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default EducationAndEmployment;
